import React, { useState, useEffect, useRef } from "react";

const ImageCarousel = ({ images, className = "", autoSlide = true, autoSlideInterval = 5000, aspect = "aspect-video", showDots = true }) => {
  const [current, setCurrent] = useState(0);
  const timeoutRef = useRef(null);

  useEffect(() => {
    if (!autoSlide || images.length <= 1) return;
    timeoutRef.current = setTimeout(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, autoSlideInterval);
    return () => clearTimeout(timeoutRef.current);
  }, [current, autoSlide, autoSlideInterval, images.length]);

  const goTo = (idx) => setCurrent(idx);

  return (
    <div className={`relative w-full ${aspect} ${className}`}>
      {/* Images */}
      {images.map((img, idx) => (
        <img
          key={idx}
          src={img}
          alt={`Slide ${idx + 1}`}
          className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-700 ${idx === current ? "opacity-100 z-10" : "opacity-0 z-0"}`}
          draggable={false}
        />
      ))}
      {/* Dots only navigation */}
      {showDots && images.length > 1 && (
        <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex space-x-2 z-20">
          {images.map((_, idx) => (
            <button
              key={idx}
              onClick={() => goTo(idx)}
              className={`w-3 h-3 rounded-full border-2 border-white ${idx === current ? "bg-red-600" : "bg-white/70"} transition-all duration-300 shadow`}
              aria-label={`Go to slide ${idx + 1}`}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default ImageCarousel;
